export const canSubmitSimpleCheck = ({
  userRole,
  userPermissions,
  tradingName,
}) => {
  const allowedBrandNames = [
    "Secure For Life Wealth Management Limited",
    "Trusted Life Ltd",
    // "NeedingAdvice.co.uk Ltd 1",
    // "thefinancewomen.co.uk",
  ];

  const isAdviserPermission =
    userRole === "Advisers" && allowedBrandNames.includes(tradingName);
  const isAdminPermission =
    userRole === "Administrators" && allowedBrandNames.includes(tradingName);

  const isStaffPermission =
    userRole === "Staff" && userPermissions.includes("Check ² Admin");

//   console.log("isAdviserPermission:", isAdviserPermission);
//   console.log("isStaffPermission:", isStaffPermission);
//   console.log("isAdminPermission:", isAdminPermission);

  return isAdviserPermission || isStaffPermission || isAdminPermission;
};
